export const getQueryParams = (): Record<string, unknown> => {
  return Object.fromEntries(new URLSearchParams(window.location.search))
}

export const getQueryParamsFromString = (urlLikeString: string): Record<string, unknown> => {
  return Object.fromEntries(new URLSearchParams(urlLikeString.split('?')[1]))
}

export const getAdditionalQueryParameters = (): Record<string, unknown> => {
  const queryParams = getQueryParams()

  const parameterI = queryParams.i as string
  const parameterP = queryParams.p as string
  const parameterL = queryParams.l as string
  const parameterC = queryParams.c as string
  const parameterF = queryParams.f as string

  return {
    i: parameterI,
    p: parameterP,
    l: parameterL,
    c: parameterC,
    f: parameterF,
  }
}

export const appendDefinedQueryParams = (
  url: string,
  params: Record<string, string | number | boolean | null | undefined>,
): string => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value))
    }
  })

  const queryString = searchParams.toString()

  if (!queryString) {
    return url
  }

  return `${url}${url.includes('?') ? '&' : '?'}${queryString}`
}
